import { useConfigurationQuery } from 'App/actions/api/configuration';
import { getModules } from 'App/domain/configuration';

export const useModules = () => {
  const { data } = useConfigurationQuery();
  return getModules(data);
};
